import React from "react";
import { T } from "../theme";

// Invoice state pill, shared by the session block and the retainer ledger.
// paid | sent | invoiced → neutral/positive; pending | part → amber.
export default function InvoicePill({ invoice }) {
  const styles = {
    paid:     { label: "Paid",          bg: T.statusOnBg,   color: T.statusOn },
    sent:     { label: "Invoiced",      bg: T.bgNeutral,    color: T.fgSecondary },
    invoiced: { label: "Invoiced",      bg: T.bgNeutral,    color: T.fgSecondary },
    part:     { label: "Part invoiced", bg: T.statusRiskBg, color: T.statusRisk },
    pending:  { label: "To invoice",    bg: T.statusRiskBg, color: T.statusRisk },
  }[invoice];
  if (!styles) return null;
  return <span style={{ fontSize: 10, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", padding: "3px 8px", borderRadius: T.radiusPill, background: styles.bg, color: styles.color, whiteSpace: "nowrap" }}>{styles.label}</span>;
}
